const facilities = [
  {
    name: "Sarasota Main Post Office",
    address: "1945 Fruitville Rd, Sarasota, FL 34236",
    phone: "(941) 361-8843",
    hours: "Mon–Fri 9:00 AM – 4:00 PM, Sat 9:00 AM – 12:00 PM",
    note: "Full passport acceptance services. Accepts walk-ins for application submission, but call ahead for current wait times.",
    link: "https://tools.usps.com/find-location.htm?location=1370225",
  },
  {
    name: "Bradenton Post Office",
    address: "1115 8th Ave W, Bradenton, FL 34205",
    phone: "(941) 747-3526",
    hours: "Mon–Fri 9:00 AM – 4:00 PM",
    note: "Passport acceptance facility for Manatee County residents. Appointment recommended.",
    link: "https://tools.usps.com/find-location.htm?location=1370273",
  },
  {
    name: "Venice Post Office",
    address: "400 Venice Blvd, Venice, FL 34285",
    phone: "(941) 488-2177",
    hours: "Mon–Fri 9:00 AM – 4:00 PM, Sat 9:00 AM – 12:00 PM",
    note: "Convenient for Venice, Nokomis, and South Sarasota residents. Passport photos available on-site.",
    link: "https://tools.usps.com/find-location.htm?location=1370249",
  },
  {
    name: "Lakewood Ranch Post Office",
    address: "11010 Lakewood Ranch Blvd, Lakewood Ranch, FL 34202",
    phone: "(941) 753-1234",
    hours: "Mon–Fri 9:00 AM – 4:00 PM",
    note: "Serves the fast-growing Lakewood Ranch and East Sarasota communities. Passport acceptance by appointment.",
    link: "https://tools.usps.com/find-location.htm?location=1370341",
  },
];

export default function SarasotaAcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Facilities Near Sarasota
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants and minors must visit a passport acceptance clerk to verify identity and witness signatures. Here are the closest facilities to Sarasota, Bradenton, and Venice.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {facilities.map((f, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 hover:border-[#F6C344] transition-all"
            >
              <div className="flex items-start justify-between gap-3 mb-3">
                <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                <span className="bg-[#1A365D] text-white text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap flex-shrink-0">
                  Acceptance Clerk
                </span>
              </div>
              <p className="text-gray-500 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                {f.address}
              </p>
              <p className="text-gray-500 text-sm mb-1">
                <i className="ri-phone-line text-[#F6C344] mr-1.5"></i>
                {f.phone}
              </p>
              <p className="text-gray-400 text-xs mb-3">
                <i className="ri-time-line text-[#F6C344] mr-1.5"></i>
                {f.hours}
              </p>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{f.note}</p>
              <a
                href={f.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors whitespace-nowrap"
              >
                <i className="ri-external-link-line text-sm"></i> USPS Location Details
              </a>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-information-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-sm">Do I need to visit an acceptance clerk?</p>
            <p className="text-white/70 text-sm mt-1">
              If you are applying for your <strong className="text-white">first U.S. passport</strong> or are <strong className="text-white">under age 16</strong>, yes — an acceptance clerk must verify your identity and witness your signature. Renewals and some replacements typically do not require a clerk visit. Fast Passport Center provides exact instructions for your situation after you start your order.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
}